import DOMPurify from "dompurify";

// Tags que a resposta da IA pode usar. Antes só <a> passava, e passo a passo, listas e
// negrito viravam um bloco único de texto.
const TAGS_PERMITIDAS = ["a", "p", "br", "ul", "ol", "li", "strong", "b", "em", "i", "code"];
const ATRIBUTOS_PERMITIDOS = ["href", "target", "rel"];

const ITEM_NUMERADO = /^\s*\d+[.)]\s+/;
const ITEM_MARCADO = /^\s*[-*•]\s+/;

// Quando a resposta chega como texto corrido (sem tags de bloco), converte quebras de linha,
// listas "1." / "-" e **negrito** em HTML.
const textoParaHtml = (texto: string) => {
  const linhas = texto.replace(/\r\n/g, "\n").split("\n");
  const blocos: string[] = [];
  let lista: { tipo: "ol" | "ul"; itens: string[] } | null = null;
  let paragrafo: string[] = [];

  const fecharParagrafo = () => {
    if (paragrafo.length) blocos.push(`<p>${paragrafo.join("<br>")}</p>`);
    paragrafo = [];
  };
  const fecharLista = () => {
    if (lista) blocos.push(`<${lista.tipo}>${lista.itens.map((i) => `<li>${i}</li>`).join("")}</${lista.tipo}>`);
    lista = null;
  };

  for (const linha of linhas) {
    const tipo = ITEM_NUMERADO.test(linha) ? "ol" : ITEM_MARCADO.test(linha) ? "ul" : null;
    if (tipo) {
      fecharParagrafo();
      if (lista && lista.tipo !== tipo) fecharLista();
      if (!lista) lista = { tipo, itens: [] };
      lista.itens.push(linha.replace(tipo === "ol" ? ITEM_NUMERADO : ITEM_MARCADO, ""));
    } else if (linha.trim() === "") {
      fecharParagrafo();
      fecharLista();
    } else {
      fecharLista();
      paragrafo.push(linha);
    }
  }
  fecharParagrafo();
  fecharLista();

  return blocos.join("").replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
};

export const formatarResposta = (resposta: string) => {
  const comRel = resposta.replace(
    /<a\b([^>]*?)\btarget="_blank"/g,
    '<a$1 target="_blank" rel="noopener noreferrer"'
  );
  const temBlocos = /<(p|ul|ol|li|br)\b/i.test(comRel);

  return DOMPurify.sanitize(temBlocos ? comRel : textoParaHtml(comRel), {
    ALLOWED_TAGS: TAGS_PERMITIDAS,
    ALLOWED_ATTR: ATRIBUTOS_PERMITIDOS,
  });
};
